import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { Uklad } from './components/Uklad';
import { Logowanie } from './pages/Logowanie';
import { ZmianaHasla } from './pages/ZmianaHasla';
import { Pulpit } from './pages/Pulpit';
import { Uzytkownicy } from './pages/Uzytkownicy';
import { Role } from './pages/Role';
import { Dziennik } from './pages/Dziennik';
import { Kartoteka } from './pages/Kartoteka';
import { Sprzet } from './pages/Sprzet';
import { Lokalizacje } from './pages/Lokalizacje';
import { LokalizacjaSzczegoly } from './pages/LokalizacjaSzczegoly';
import { Partie } from './pages/Partie';
import { Slowniki } from './pages/Slowniki';
import { Stany } from './pages/Stany';
import { Dokumenty } from './pages/Dokumenty';
import { NowyDokument } from './pages/NowyDokument';
import { Zajecia } from './pages/Zajecia';
import { Zestawy } from './pages/Zestawy';
import { Rezerwacje } from './pages/Rezerwacje';
import { Rozliczenie } from './pages/Rozliczenie';
import { Serwis } from './pages/Serwis';
import { Inwentaryzacja } from './pages/Inwentaryzacja';
import { Etykiety } from './pages/Etykiety';
import { Raporty } from './pages/Raporty';
import { Eksporty } from './pages/Eksporty';
import { Komunikat } from './components/ui';

function Chronione({ uprawnienie, children }: { uprawnienie: string; children: React.ReactNode }) {
  const { maUprawnienie } = useAuth();
  if (!maUprawnienie(uprawnienie)) {
    return (
      <Komunikat rodzaj="uwaga" tytul="Brak dostępu">
        Twoja rola nie obejmuje tej części systemu. Jeśli powinna — poproś administratora
        o rozszerzenie uprawnień.
      </Komunikat>
    );
  }
  return <>{children}</>;
}

export function App() {
  const { uzytkownik, wczytywanie } = useAuth();

  if (wczytywanie) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-kamien-500">
        Wczytywanie...
      </div>
    );
  }

  if (!uzytkownik) return <Logowanie />;

  // Do czasu ustawienia własnego hasła serwer i tak odrzuca pozostałe żądania.
  if (uzytkownik.mustChangePassword) return <ZmianaHasla wymuszona />;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Uklad />}>
          <Route index element={<Pulpit />} />
          <Route path="haslo" element={<ZmianaHasla wymuszona={false} />} />

          <Route
            path="stany"
            element={<Chronione uprawnienie="kartoteka.odczyt"><Stany /></Chronione>}
          />
          <Route
            path="dokumenty"
            element={<Chronione uprawnienie="kartoteka.odczyt"><Dokumenty /></Chronione>}
          />
          <Route
            path="dokumenty/nowy"
            element={<Chronione uprawnienie="kartoteka.odczyt"><NowyDokument /></Chronione>}
          />
          <Route
            path="rozliczenie/:id"
            element={<Chronione uprawnienie="kartoteka.odczyt"><Rozliczenie /></Chronione>}
          />
          <Route
            path="zajecia"
            element={<Chronione uprawnienie="zajecia.odczyt"><Zajecia /></Chronione>}
          />
          <Route
            path="zestawy"
            element={<Chronione uprawnienie="zestawy.odczyt"><Zestawy /></Chronione>}
          />
          <Route
            path="rezerwacje"
            element={<Chronione uprawnienie="rezerwacje.odczyt"><Rezerwacje /></Chronione>}
          />
          <Route
            path="serwis"
            element={<Chronione uprawnienie="serwis.odczyt"><Serwis /></Chronione>}
          />
          <Route
            path="inwentaryzacja"
            element={<Chronione uprawnienie="inwentaryzacja.spis"><Inwentaryzacja /></Chronione>}
          />
          <Route path="etykiety" element={<Etykiety />} />
          <Route
            path="raporty"
            element={<Chronione uprawnienie="raporty.odczyt"><Raporty /></Chronione>}
          />
          <Route
            path="eksporty"
            element={<Chronione uprawnienie="raporty.eksport"><Eksporty /></Chronione>}
          />
          <Route
            path="kartoteka"
            element={<Chronione uprawnienie="kartoteka.odczyt"><Kartoteka /></Chronione>}
          />
          <Route
            path="sprzet"
            element={<Chronione uprawnienie="sprzet.odczyt"><Sprzet /></Chronione>}
          />
          <Route
            path="partie"
            element={<Chronione uprawnienie="kartoteka.odczyt"><Partie /></Chronione>}
          />
          <Route path="lokalizacje" element={<Lokalizacje />} />
          <Route path="lokalizacje/:id" element={<LokalizacjaSzczegoly />} />
          <Route
            path="slowniki"
            element={<Chronione uprawnienie="kartoteka.zapis"><Slowniki /></Chronione>}
          />
          <Route
            path="uzytkownicy"
            element={<Chronione uprawnienie="uzytkownicy.zarzadzanie"><Uzytkownicy /></Chronione>}
          />
          <Route path="role" element={<Role />} />
          <Route
            path="dziennik"
            element={<Chronione uprawnienie="dziennik.odczyt"><Dziennik /></Chronione>}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
